
import { isMobile } from '@/lib/device'
import {
  orgIndex,
  createOrgItem,
  createProject,
  getAdminId,
  editProjectName,
  delProject,
  closeProject,
  openProject,
  editOrgName,
  tranfOrgFirst,
  tranfOrgSecond,
  dismissOrg,
  tranfSelectDatas,
  projectTo,
  fetchProjectList,
  fetchOrgDetail
} from '@/services/organization'
import rules from './rules'
import { message } from 'ant-design-vue'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    submitting: false,
    datas: {},
    adminListDatas: [],
    // datas数据是否准备就绪
    datasReady: false,
    orgDatas: {},
    orgDatasReady: false,
    baseinfoData: {},
    orgSelectDatas: [],
    decorators: {
      comname: ['comname', { rules: rules.orgname }],
      projectname: ['projectname', { rules: rules.projectname }],
      adminid: ['adminid', { rules: rules.adminlist }],
      checkcode: ['checkcode', { rules: rules.validCode }],
      transferuserid: ['transferuserid', { rules: rules.transferuserid }],
      pid: ['pid', { rules: rules.pid }]
    },
    // 隐藏项目
    ishidden: 0,
    projectType: 'member',
    isManage: true,
    comName: '',
    comDatas: {}
  },
  mutations: {
    // 设置数据容器的值
    setDatas (state, datas) {
      state.datas = datas
      state.datasReady = true
    },
    // 组织数据
    setOrgDatas (state, datas) {
      state.orgDatas = datas
      state.orgDatasReady = true
    },
    setComName (state, name) {
      state.comName = name
    },
    setSubmitting (state, type) {
      state.submitting = type
    },
    // 设置管理员
    setAdmin (state, data) {
      state.admin = data
    },
    // 设置管理员
    setFounder (state, data) {
      state.founder = data
    },
    setAdminListDatas (state, datas) {
      state.adminListDatas = datas
    },
    setBaseinfoData (state, data) {
      state.baseinfoData = data
    },
    setOrgSelectDatas (state, datas) {
      state.orgSelectDatas = datas
    },
    setIsHidden (state, hidden) {
      state.ishidden = hidden
    },
    setProjectType (state, type) {
      state.projectType = type
    },
    setIsManage (state, b) {
      state.isManage = b
    },
    setComDatas (state, data) {
      state.comDatas = data
    }
  },
  actions: {
    // 获取组织项目默认数据
    async fetchOrgDatas ({ commit }) {
      // commit('setSubmitting', true)
      const chain = await orgIndex()
        .onSuccess((raw, res) => {
          commit('setOrgDatas', raw)
          commit('setBaseinfoData', res.baseinfo)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .onNetSuccess(raw => {
          const res = raw.data
          if (res.error && (res.error !== 101)) {
            message.error(res.message)
          }
        })
        .config({ tip: false, warn: false })
      return chain
    },
    // 获取项目
    async fetchProjectList ({ commit }, cid) {
      // commit('setSubmitting', true)
      const chain = await fetchProjectList()
      chain.params(cid)
        .onSuccess((raw, res) => {
          commit('setDatas', raw)
          // commit('setIsManage', !!raw.isadmin || !!raw.isfounder)
          commit('setBaseinfoData', res.baseinfo)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .onNetSuccess(raw => {
          const res = raw.data
          if (res.error && (res.error !== 101)) {
            message.error(res.message)
            setTimeout(() => {
              router.push({ name: 'OrgIndex' })
            }, 1000)
          }
        })
        .config({ tip: false, warn: false })
      return chain
    },
    // 获取组织信息
    async fetchOrgDetail ({ commit }, cid) {
      // commit('setSubmitting', true)
      const chain = await fetchOrgDetail()
        .params(cid)
        .onSuccess((raw, res) => {
          commit('setComDatas', raw)
          commit('setComName', raw.comname)
          commit('setBaseinfoData', res.baseinfo)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .onNetSuccess(raw => {
          const res = raw.data
          if (res.error && (res.error !== 101)) {
            // message.error(res.message)
          }
        })
        .config({ tip: false, warn: false })
      return chain
    },
    // 创建组织
    async ajaxCreateOrg ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await createOrgItem()
        .onSuccess(async () => {
          const res = await dispatch('fetchOrgDatas')
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 修改组织名称
    async ajaxEditOrg ({ commit, dispatch }, data) {
      commit('setSubmitting', true)
      const chain = await editOrgName()
        .onSuccess(async () => {
          let res = null
          if (isMobile) {
            res = await dispatch('fetchOrgDatas')
          } else {
            res = await dispatch('fetchOrgDetail', data)
          }
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 转让组织第一步
    async ajaxFirstTranOrg ({ commit, dispatch }, data) {
      commit('setSubmitting', true)
      const chain = await tranfOrgFirst()
        .onSuccess(async () => {
          let res = null
          if (isMobile) {
            res = await dispatch('fetchOrgDatas')
          } else {
            res = await dispatch('fetchOrgDetail', data)
          }
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 转让组织第二步
    async ajaxSecondTranOrg ({ commit, dispatch }, data) {
      commit('setSubmitting', true)
      const chain = await tranfOrgSecond()
        .onSuccess(async () => {
          let res = null
          if (isMobile) {
            res = await dispatch('fetchOrgDatas')
          } else {
            res = await dispatch('fetchOrgDetail', data)
          }
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 转让组织获取可选数据
    async fetchOrgSelectDatas ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await tranfSelectDatas()
        .onSuccess((res) => {
          commit('setOrgSelectDatas', res.list)
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 解散组织
    async ajaxDismissOrg ({ commit, dispatch }) {
      commit('setSubmitting', true)
      const chain = await dismissOrg()
        .onSuccess(async () => {
          if (isMobile) {
            let res = await dispatch('fetchOrgDatas')
            res.fetch()
          }
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 创建项目
    async ajaxCreateProject ({ commit, dispatch }, cid) {
      commit('setSubmitting', true)
      const chain = await createProject()
        .onSuccess(async () => {
          const res = await dispatch('fetchProjectList', cid)
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 修改项目名称
    async ajaxEditPro ({ commit, dispatch }, cid) {
      commit('setSubmitting', true)
      const chain = await editProjectName()
        .onSuccess(async () => {
          const res = await dispatch('fetchProjectList', cid)
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 关闭项目
    async ajaxClosePro ({ commit, dispatch, state }, cid) {
      commit('setSubmitting', true)
      const chain = await closeProject()
        .onSuccess(async () => {
          const res = await dispatch('fetchProjectList', cid)
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 重新打开项目
    async ajaxOpenPro ({ commit, dispatch }, cid) {
      commit('setSubmitting', true)
      const chain = await openProject()
        .onSuccess(async () => {
          const res = await dispatch('fetchProjectList', cid)
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 删除项目
    async ajaxDelPro ({ commit, dispatch }, cid) {
      commit('setSubmitting', true)
      const chain = await delProject()
        .onSuccess(async () => {
          const res = await dispatch('fetchProjectList', cid)
          res.fetch()
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
      return chain
    },
    // 创建项目时，获取管理员id
    async getAdminId ({ commit }) {
      const chain = await getAdminId()
        .onSuccess((raw) => {
          commit('setAdminListDatas', raw.list)
        })
        .config({ tip: false })
      return chain
    },

    // 从项目跳转后台 请求
    // 创建项目时，获取管理员id
    async projectToLink ({ commit }) {
      // commit('setSubmitting', true)
      const chain = await projectTo()
        .onSuccess((raw) => {
        })
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }
    // async login ({ commit }, payload) {
    //   console.log('xxx')
    //   commit('setSubmitting', true)
    //   await accountLogin()
    //     .params(payload)
    //     .fetch()
    //   commit('setSubmitting', false)
    //   //
    // }
    // async login ({ commit }) {
    //   console.log('xxx')
    //   commit('setSubmitting', true)
    //   const api = await accountLogin()
    //     .final(() => {
    //       commit('setSubmitting', false)
    //     })
    //   return api
    //   // ajax
    //   //
    // }
  }
}
